module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6be143c7cb9d23c787f7f20674a76f72.svg";